import {
  STARTAPI_REQUEST_UNSEAL_TEC,
  SENDAPI_REQUEST_UNSEAL_TEC,
} from './constants'
const initialState = {
  data: '',
}
export const resultStartApiReqUnsealTec = (state = initialState, action) => {
  switch (action.type) {
    case STARTAPI_REQUEST_UNSEAL_TEC:
      return {
        ...state,
        data: action.message,
      }
    case SENDAPI_REQUEST_UNSEAL_TEC:
      return {
        ...state,
        data: action.message,
      }
    default:
      return state
  }
}
